import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforma un código de país ISO 3166-1 alpha-2 (ej. "CO", "US") en el nombre del país en español
 * usando Intl.DisplayNames. Si no está disponible o falla, devuelve el código tal cual.
 */
@Pipe({ name: 'countryName' })
export class CountryNamePipe implements PipeTransform {
  transform(iso2: string | null | undefined): string {
    if (iso2 === null || iso2 === undefined) {
      return '';
    }
    const code = String(iso2).trim();
    if (!code) {
      return '';
    }
    try {
      if (typeof Intl !== 'undefined' && (Intl as any).DisplayNames) {
        return new (Intl as any).DisplayNames(['es'], { type: 'region' }).of(code) || code;
      }
    } catch {}
    return code;
  }
}